import React from "react";
import { Skeleton } from "antd";

export const CoreSkeleton: React.FC = () => {
  return (
    <div className="bg-white w-full mx-auto mb-12 mt-12 p-10 flex justify-center items-center border-black rounded">
      <Skeleton active paragraph={{ rows: 10 }} />
    </div>
  );
};
